import { TranslateFunction } from 'react-localize-redux';

import { AppConfig } from '../core/api/whitelabel/whitelabel.types';
import { checkCountryCode } from './locationUtils';

export const getTaxLabel = (
  configData: AppConfig,
  translate: TranslateFunction,
): string => {
  const isAustralianWhiteLabel = checkCountryCode(configData, 'AU');
  const taxLabel = isAustralianWhiteLabel
    ? translate('OrderDetails_gstIncluded')
    : translate('Tax');

  return taxLabel as string;
};

export const replaceCollectionWithPickup = (
  translation: string,
  countryCode = '',
): string => {
  const countryCodes = ['AU', 'BS', 'CA', 'PR', 'NZ'];

  if (countryCodes.includes(countryCode)) {
    const newString = translation
      .replace('collection', 'pickup')
      .replace('Collection', 'Pickup');
    return newString;
  }

  return translation;
};

export const formatDynamicString = (
  stringToFormat: string,
  stringsToInsert: string[],
): string => {
  let formattedString = stringToFormat;

  stringsToInsert.forEach((stringToInsert, index) => {
    formattedString = formattedString.replace(`{${index}}`, stringToInsert);
  });

  return formattedString;
};
